import flatten from 'lodash-es/flatten';

import { normalizeProducts } from '@df/catalog-ui/related-products/normalize-products.fn';
import { Product } from '@df/catalog/product/product';
import { ProductResource } from '@df/catalog/product/product.resource';
import { NgInject } from '@df/ng/ng-inject';
import { ModelCarouselEngine } from './model-carousel-engine';
import { IModelCarouselLoadRequest } from './model-carousel.interface';
import { ModelCarouselService } from './model-carousel.service';

export interface IModelCarouselAttributeLoadRequest extends IModelCarouselLoadRequest {
    attributeCode: string[];
}

export class ModelCarouselAttributeEngine extends ModelCarouselEngine<Product> {
    @NgInject(ProductResource)
    productResource!: ProductResource;

    get(type: string, data: IModelCarouselAttributeLoadRequest): Promise<Product[]> {
        return new Promise(resolve => {
            const attributeCodes = data?.attributeCode;
            const sourceIds = data.ids || [];
            if (attributeCodes?.length && sourceIds.length) {
                const filter = {};

                attributeCodes.forEach(code => {
                    const values = flatten(this.productResource.getAllExisting(sourceIds).map(i => i.data?.[code])).filter(i => !!i);
                    if (values?.length) {
                        filter[code] = { $in: values };
                    }
                });

                if (Object.keys(filter).length > 0) {
                    this.productResource
                        .find({ verbosity: 2, filter })
                        .then((products: Product[]) => {
                            const productsIds = this.productResource.toIds(products);
                            const finalIds = normalizeProducts(sourceIds, productsIds, true);
                            resolve(this.productResource.toModels(finalIds));
                        })
                        .catch(() => {
                            resolve([]);
                        });
                } else {
                    resolve([]);
                }
            } else {
                resolve([]);
            }
        });
    }
}

ModelCarouselService.engines['attribute'] = new ModelCarouselAttributeEngine();
